import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { Endpoints } from '@/remote/endpoints'


export const LoadConsultor = (perfis: number[]) => {
  const { getUnitId } = useLocalStorage()
 const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      httpClientPost(
        Endpoints.users + '/filtro?page=0&size=1000&order=desc&sort=id',
        {
          perfis: perfis,
          idUnidade: [parseInt(getUnitId())]
        }
      )
        .then((response) => {
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: item.nome,
              value: item.id
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [])

  return {
    data
  }
}
